import styles from "./footer.module.css";
import whiteArrow from "../../assets/image/white-arrow.svg";
import emailIcon from "../../assets/image/email-logo.svg";
import instagramIcon from "../../assets/image/instagram.svg";
import xIcon from "../../assets/image/x-logo.svg";
import linkedInIcon from "../../assets/image/linkdeln-logo.svg";
import contactIcon from "../../assets/image/contact-icon.svg";

const Footer = () => {
  return (
    <footer>
      <div
        className={styles.topFooterLayout}
        style={{
          backgroundImage:
            "url('/assets/background-Image/footer-background-image.webp')",
        }}
      >
        <div className={styles.topFooterDetails}>
          <h3>Have Questions or Need More Information?</h3>
          <p>
             We’d love to hear from you. Whether you want to volunteer, sponsor,
            or just learn more, our team is always available to communicate with
            you.
          </p>
          <div className={styles.socialsLayout}>
            <a href="mailto:kbklubcmul@gmail.com">
              <div className={styles.socialIcon}>
                <img src={emailIcon} alt="email" />
              </div>
            </a>
            <a
              href="https://www.instagram.com/kbklub/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.socialIcon}>
                <img src={instagramIcon} alt="instagram" />
              </div>
            </a>
            <a
              href="https://x.com/KBKLUB"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.socialIcon}>
                <img src={xIcon} alt="X or Twitter" />
              </div>
            </a>
            <a
              href="https://www.linkedin.com/company/kb-klub/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.socialIcon}>
                <img src={linkedInIcon} alt="LinkedIn" />
              </div>
            </a>
          </div>
          <div className={styles.contactsLayout}>
            <div className={styles.contactIcon}>
              <img src={contactIcon} alt="contact Icon" />
            </div>
            <div className={styles.contacts}>
              <p>+234 708 319 6728 (Sheriff)</p>
              <p>+234 818 824 6469 (Henry)</p>
              <p>+234 903 932 1696 (Mustapha)</p>
              <p>+234 902 212 8040 (Dapo)</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.bottomFooterLayout}>
        <div className={styles.bottomLeftFooterLayout}>
          <p>© 2025 KB KLUB.</p>
          <p>All Rights Reserved.</p>
        </div>
        <a
          href=" https://www.kbklub.org/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.aboutButton}
        >
          <button >
            About KB KLUB <img src={whiteArrow} alt="" />
          </button>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
